import script from "./StatisticsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsView.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticsView.vue?vue&type=style&index=0&id=5b428138&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b428138"]])

export default __exports__